<template>
    <div class="contentCenter">

        <div class="contentCenter">
            <div class="topContent">
                <p>搭乘{{ km }}公里的汽車，<br>等於製造了<span>{{ co2 }}</span>kg的二氧化碳</p>
            </div>
            <div class="yellowContent">
                <div class="iconBox">
                    <img :src="mapIcon" alt="icon">
                </div>
                <p>需要步行約<span>{{ walkByKm }}</span>公里才能抵銷這些碳排放量</p>
                <div class="iconBox">
                    <img :src="footprintIcon" alt="icon">
                </div>
                <p>約等於<span>{{ walkBySteps }}</span>步</p>
            </div>
        </div>
        <button @click.prevent="goView('/carbon/calculator/StepsCalculator')" class="calculateStyle">開始減碳行</button>
        <button @click.prevent="isShowResult" class="calculateStyle">重新計算</button>
    </div>
</template>

<script>
/* eslint-disable global-require */

export default {
    data() {
        return {
            picked: '',
            mapIcon: require('@/assets/steps-distance.png'),
            footprintIcon: require('@/assets/steps-footprint.png'),
        };
    },
    props: {
        km: {
            type: Number,
            require: false,
        },
        co2: {
            type: Number,
            require: false,
        },
        walkByKm: {
            type: Number,
            require: false,
        },
        walkBySteps: {
            type: String,
            require: false,
        },
    },
    methods: {
        submitResult() {
            this.$emit('get-result', this.picked);
        },
        isShowResult() {
            this.$emit('show-question', false);
        },
        goView(link) {
            this.$router.push(link).catch(() => { });
        },
    },
};
</script>

<style lang="sass" scoped>
.contentCenter
    .topContent
        width: 100%
        background-color: rgba(255, 255, 255, 0.6)
        padding: 16px

        p
            font-size: 22px
            font-weight: 600
        span
            font-size: 48px
    .yellowContent
        width: 100%
        display: flex
        flex-direction: column
        align-items: center
        background-color: #FFFAEE
        padding: 24px
        border-radius: 10px
        gap: 16px
        p
            font-size: 16px
            font-weight: 600
    span
        color: #F59A23
        font-size: 16px
    .iconBox
        width: 56px
        height: 56px
        img
            width: 100%
            height: 100%
            object-fit: contain
</style>
